import mapValues from 'lodash/mapValues';

import type { LabwarePropertiesV7, LoadedWorkflowV7 } from '../migrateTo7';

// make slot a required field.
export type LabwarePropertiesV8 = Omit<LabwarePropertiesV7, 'slot'> & {
  slot: string;
};

export type VisualWorkflowV8 = Omit<
  LoadedWorkflowV7['visualWorkflow'],
  'labwareProperties'
> & {
  labwareProperties: Record<string, LabwarePropertiesV8>;
};

export type LoadedWorkflowV8 = Omit<LoadedWorkflowV7, 'visualWorkflow'> & {
  visualWorkflow: VisualWorkflowV8;
};

const migrateSlot = (slot: string | undefined): string => slot || '1';

export const _migrateTo8 = (
  loadedWorkflow: LoadedWorkflowV7
): LoadedWorkflowV8 => {
  const labwareProperties: VisualWorkflowV8['labwareProperties'] = mapValues(
    loadedWorkflow.visualWorkflow.labwareProperties,
    (labware) => ({
      ...labware,
      slot: migrateSlot(labware.slot),
    })
  );

  return {
    ...loadedWorkflow,
    visualWorkflow: {
      ...loadedWorkflow.visualWorkflow,
      labwareProperties,
    },
  };
};
